export const ORGANIZATION_STATUS = {
  ALLOW: "ALLOW",
  PAID: "PAID",
  BLOCK: "BLOCK"
};

export const organizationStatusFormatter = status => {
  let str;
  switch (status) {
    case ORGANIZATION_STATUS.ALLOW:
      str = "ALLOW";
      break;
    case ORGANIZATION_STATUS.PAID:
      str = "PAID";
      break;
    case ORGANIZATION_STATUS.BLOCK:
      str = "BLOCK";
      break;

    default:
      str = "";
      break;
  }
  return str;
};

export const ORGANIZATION_STATUS_OPTION = [
  {
    label: ORGANIZATION_STATUS.ALLOW,
    value: ORGANIZATION_STATUS.ALLOW
  },
  {
    label: ORGANIZATION_STATUS.BLOCK,
    value: ORGANIZATION_STATUS.BLOCK
  },
  {
    label: ORGANIZATION_STATUS.PAID,
    value: ORGANIZATION_STATUS.PAID
  }
];

export const IS_ACTIVE = [
  {
    value: true,
    label: "AKTIF"
  },
  {
    value: false,
    label: "TIDAK AKTIF"
  }
];

export const IS_EXPIRED = [
  {
    value: true,
    label: "EXPIRED"
  },
  {
    value: false,
    label: "BELUM EXPIRED"
  }
];

export const CORPS = {
  SIMPZ: "SIMPZ",
  DONORIAN: "DONORIAN"
};

export const ROLE_CORPS = {
  [CORPS.SIMPZ]: [],
  [CORPS.DONORIAN]: ["organization_payment_status"]
};

export const checkRoleCorp = (corp, action) => {
  corp = corp ? corp : "donorian";
  return ROLE_CORPS[corp.toString().toUpperCase()].includes(action);
};

export function capitalizeFirstLetter(string) {
  if (string) {
    string = string.toLowerCase().replace("_", " ");
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}

export const getFolderLabel = label => {
  let str;
  switch (label) {
    case ORGANIZATION_FILE_TYPE.ID_CARD:
      str = "KTP";
      break;
    case ORGANIZATION_FILE_TYPE.FINANCIAL_STATEMENTS:
      str = "Laporan keuangan 1 tahun terakhir";
      break;
    case ORGANIZATION_FILE_TYPE.AGREEMENT:
      str = "Form pemahaman dan persetujuan";
      break;
    case ORGANIZATION_FILE_TYPE.PARTNER_PROFILE:
      str = "Form profil mitra";
      break;
    case ORGANIZATION_FILE_TYPE.OTHERS:
      str = "Dokumen lainnya";
      break;
    case ORGANIZATION_FILE_TYPE.MLHR:
      str = "SK Kemenkumham";
      break;

    default:
      str = capitalizeFirstLetter(label);
      break;
  }
  return str;
};

// export const organizationFileType = {
//   // Ministry of Law and Human Rights / Kemenkumham
//   MLHR: "MLHR",
//   // Deed of Incorporation / Akta Pendirian
//   DI: "DI",
//   // Domicile / Domisili
//   DOMICILE: "DOMICILE",
//   OTHERS: "OTHERS"
// };

export const ORGANIZATION_FILE_TYPE = {
  // Financial statements for the last 1 year / Laporan keuangan 1 tahun terakhir
  FINANCIAL_STATEMENTS: "FINANCIAL_STATEMENTS",
  // Partner profile form / Form profil mitra
  PARTNER_PROFILE: "PARTNER_PROFILE",
  // Form pemahaman dan persetujuan
  AGREEMENT: "AGREEMENT",
  // Ministry of Law and Human Rights / Kemenkumham
  MLHR: "SK_KEMEKUMHAM",
  // Deed of Incorporation / Akta Pendirian
  DI: "AKTA_PENDIRIAN",
  // Struktur Kepengurusan
  MANAGEMENT_STRUCTURE: "STRUKTUR_KEPENGURUSAN",
  // Surat Pengajuan untuk menjadi mpz
  SUBMISSION_LETTER: "SURAT_PENGAJUAN",
  // KTP 3 Pengurus inti
  ID_CARD: "KTP",
  OTHERS: "OTHERS"
};

export const generateYearsBetween = (startYear = 2010, endYear) => {
  const endDate = endYear || new Date().getFullYear();
  let years = [];

  for (let i = startYear; i <= endDate; i++) {
    years.push(startYear);
    startYear++;
  }
  return years;
};

export const toMonthName = monthNumber => {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString("id", {
    month: "long"
  });
};

export const organizationInstructionList = [
  "Surat pengajuan menjadi MPZ",
  "Mengisi form profile mitra",
  "Melampirkan scan KTP 3 orang pengurus inti (Ketua, Sekretaris, Bendahara)",
  "Melampirkan laporan keuangan bulanan tahun terakhir",
  "Melampirkan strukur pengurus mitra dan LAZnya (bila LAZ menjadi unit tersendiri)",
  "Melampirkan form pemahaman dan persetujuan"
  // "Melampirkan bukti Legalitas (untuk masjid/surau cukup dengan SK kepengurusan)"
];

export const DONATION_STATUS = {
  RECOG: "RECOG",
  SETTLE: "SETTLE",
  DRAFT: "DRAFT",
  REQUEST_VOID: "REQUEST_DELETE",
  VOID: "VOID",
  COMMIT: "COMMIT"
};

export const SIMPZ_STATUS = {
  REGISTRATION: "REGISTRATION",
  DATA_UPLOAD: "DATA_UPLOAD",
  SUBMIT: "SUBMIT",
  ACTIVE: "ACTIVE"
};

export const ORG_CONSOLIDATION_STATUS = {
  SUBMIT: "SUBMIT",
  REVIEW: "REVIEW",
  MPZ_APPROVAL_MANAGEMENT: "MPZ_APPROVAL_MANAGEMENT",
  FINANCE: "FINANCE",
  PAID: "PAID"
};

export const ORG_CONSOLIDATION_STATUS_DESC = {
  SUBMIT: "SUBMIT",
  REVIEW: "REVIEW",
  MPZ_APPROVAL_MANAGEMENT: "MPZ APPROVAL MANAGEMENT",
  FINANCE: "KEUANGAN",
  PAID: "PAID"
  // SUBMIT: "Telah Dikirim",
  // REVIEW: "Sedang Diperiksa",
  // MPZ_APPROVAL_MANAGEMENT: "Management",
  // FINANCE: "Keuangan",
  // PAID: "Dibayarkan"
};

export const DONOR_IMPORT_FIELDS = {
  "Tipe Donatur *": "type",
  "Nama *": "name",
  Sapaan: "greeting",
  HP: "hp",
  Email: "email",
  Alamat: "address",
  Kecamatan: "district",
  Kota: "city",
  Provinsi: "province",
  Kodepos: "postal_code",
  "NIK / Nomor KTP / Nomor Perusahaan": "nik",
  NPWP: "npwp",
  NPWZ: "npwz",
  "Status Hidup": "is_alive",
  "Status Keaktifan": "is_active",
  "Kode Rekening": "kode_rekening"
};

export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 }
];

export const roleExplanation = [
  {
    subject: "user",
    action: "Create",
    explanation: "Membuat user baru"
  },
  {
    subject: "user",
    action: "Read",
    explanation: "Melihat data user"
  },
  {
    subject: "user",
    action: "Edit",
    explanation: "Mengubah data user"
  },
  {
    subject: "user",
    action: "Edit Channel",
    explanation: "Melakukan perubahan channel user"
  },
  {
    subject: "user",
    action: "Edit Cabang",
    explanation: "Melakukan perubahan cabang user"
  },
  {
    subject: "donasi",
    action: "Read",
    explanation: "Melihat data donasi"
  },
  {
    subject: "bank_import",
    action: "Read",
    explanation: "Melihat data import bank"
  },
  {
    subject: "bank_import",
    action: "Edit",
    explanation: "Mengubah data import bank"
  },
  {
    subject: "bank_import",
    action: "Proses Data",
    explanation: "Melakukan proses data import bank"
  },
  {
    subject: "bank_import",
    action: "Import Bank",
    explanation: "Melakukan import bank"
  },
  {
    subject: "konfirmasi_donasi",
    action: "Read",
    explanation: "Melihat data konfirmasi donasi"
  },
  {
    subject: "konfirmasi_donasi",
    action: "Read Own",
    explanation: "Melihat data konfirmasi donasi sendiri"
  },
  {
    subject: "konfirmasi_donasi",
    action: "Edit",
    explanation: "Mengubah data konfirmasi donasi"
  },
  {
    subject: "konfirmasi_donasi",
    action: "Create",
    explanation: "Membuat data konfirmasi donasi"
  },
  {
    subject: "konfirmasi_donasi",
    action: "Delete",
    explanation: "Menghapus data konfirmasi donasi"
  },
  {
    subject: "konfirmasi_donasi",
    action: "Choose Donation",
    explanation: "Memilih donasi untuk konfirmasi"
  },
  {
    subject: "konfirmasi_donasi",
    action: "Manual Confirmation",
    explanation: "Melakukan konfirmasi manual"
  },
  {
    subject: "rekap_donasi",
    action: "Read",
    explanation: "Melihat data rekap donasi"
  },
  {
    subject: "list_donasi",
    action: "Read",
    explanation: "Melihat data list donasi"
  },
  {
    subject: "list_donasi",
    action: "Read Own",
    explanation: "Melihat data list donasi sendiri"
  },
  {
    subject: "list_donasi",
    action: "Request Void",
    explanation: "Membuat permintaan pembatalan donasi"
  },
  {
    subject: "list_donasi",
    action: "Request Void",
    explanation: "Membuat permintaan pembatalan donasi"
  },
  {
    subject: "list_donasi",
    action: "Export Donation",
    explanation: "Mengekspor data donasi"
  },
  {
    subject: "list_donasi",
    action: "Filter Kota",
    explanation: "Melakukan filter kota"
  },
  {
    subject: "list_donasi",
    action: "Filter Status Donasi",
    explanation: "Melakukan filter status donasi"
  },
  {
    subject: "list_donasi",
    action: "Filter Channel Type",
    explanation: "Melakukan filter channel type"
  },
  {
    subject: "list_donasi",
    action: "Filter Bank",
    explanation: "Melakukan filter bank"
  },
  {
    subject: "list_donasi",
    action: "Filter Project",
    explanation: "Melakukan filter project"
  },
  {
    subject: "list_donasi",
    action: "Filter Channel",
    explanation: "Melakukan filter channel"
  },
  {
    subject: "list_donasi",
    action: "Filter User",
    explanation: "Melakukan filter user"
  },
  {
    subject: "wilayah",
    action: "Read",
    explanation: "Melihat data wilayah"
  },
  {
    subject: "wilayah",
    action: "Create",
    explanation: "Membuat data wilayah"
  },
  {
    subject: "wilayah",
    action: "Edit",
    explanation: "Mengubah data wilayah"
  },
  {
    subject: "wilayah",
    action: "Delete",
    explanation: "Menghapus data wilayah"
  },
  {
    subject: "mitra",
    action: "Read",
    explanation: "Melihat data mitra"
  },
  {
    subject: "mitra",
    action: "Create",
    explanation: "Membuat data mitra"
  },
  {
    subject: "mitra",
    action: "Edit",
    explanation: "Mengubah data mitra"
  },
  {
    subject: "mitra",
    action: "Delete",
    explanation: "Menghapus data mitra"
  },
  {
    subject: "detail_donasi",
    action: "Read",
    explanation: "Melihat data detail donasi"
  },
  {
    subject: "detail_donasi",
    action: "Read Own",
    explanation: "Melihat data detail donasi sendiri"
  },
  {
    subject: "detail_donasi",
    action: "Create Donation",
    explanation: "Membuat data donasi"
  },
  {
    subject: "detail_donasi",
    action: "Edit Donation Item",
    explanation: "Mengubah data item donasi"
  },
  {
    subject: "detail_donasi",
    action: "Edit Trx Date",
    explanation: "Mengubah data tanggal transaksi"
  },
  {
    subject: "detail_donasi",
    action: "Settle",
    explanation: "Melakukan penyelesaian donasi"
  },
  {
    subject: "detail_donasi",
    action: "Print Kuitansi",
    explanation: "Mencetak kuitansi"
  },
  {
    subject: "detail_donasi",
    action: "Print Wakaf",
    explanation: "Mencetak data wakaf"
  },
  {
    subject: "detail_donasi",
    action: "Kirim Notifikasi",
    explanation: "Mengirim notifikasi"
  },
  {
    subject: "detail_donasi",
    action: "Void",
    explanation: "Membatalkan donasi"
  },
  {
    subject: "detail_donasi",
    action: "Ganti Donatur",
    explanation: "Mengganti data donatur"
  },
  {
    subject: "void_donasi",
    action: "Read",
    explanation: "Melihat data pembatalan donasi"
  },
  {
    subject: "void_donasi",
    action: "Request Void",
    explanation: "Membuat permintaan pembatalan donasi"
  },
  {
    subject: "void_donasi",
    action: "Accept Void",
    explanation: "Menerima permintaan pembatalan donasi"
  },
  {
    subject: "void_donasi",
    action: "Reject Void",
    explanation: "Menolak permintaan pembatalan donasi"
  },
  {
    subject: "rekonsiliasi_donasi",
    action: "Read",
    explanation: "Melihat data rekonsiliasi donasi"
  },
  {
    subject: "rekonsiliasi_donasi",
    action: "Edit",
    explanation: "Mengubah data rekonsiliasi donasi"
  },
  {
    subject: "rekonsiliasi_donasi",
    action: "Delete",
    explanation: "Menghapus data rekonsiliasi donasi"
  },
  {
    subject: "rekonsiliasi_donasi",
    action: "Create",
    explanation: "Membuat data rekonsiliasi donasi"
  },
  {
    subject: "cicilan_kurban",
    action: "Read",
    explanation: "Melihat data cicilan kurban"
  },
  {
    subject: "cicilan_kurban",
    action: "Create",
    explanation: "Membuat data cicilan kurban"
  },
  {
    subject: "cicilan_kurban",
    action: "Edit",
    explanation: "Mengubah data cicilan kurban"
  },
  {
    subject: "hewan_kurban",
    action: "Create",
    explanation: "Membuat data hewan kurban"
  },
  {
    subject: "hewan_kurban",
    action: "Edit",
    explanation: "Mengubah data hewan kurban"
  },
  {
    subject: "hewan_kurban",
    action: "Read",
    explanation: "Melihat data hewan kurban"
  },
  {
    subject: "hewan_kurban_campaign",
    action: "Read",
    explanation: "Melihat data hewan kurban campaign"
  },
  {
    subject: "hewan_kurban_campaign",
    action: "Create",
    explanation: "Membuat data hewan kurban campaign"
  },
  {
    subject: "hewan_kurban_campaign",
    action: "Edit",
    explanation: "Mengubah data hewan kurban campaign"
  },
  {
    subject: "hewan_kurban_campaign",
    action: "Delete",
    explanation: "Menghapus data hewan kurban campaign"
  },
  {
    subject: "periode_kurban",
    action: "Read",
    explanation: "Melihat data periode kurban"
  },
  {
    subject: "periode_kurban",
    action: "Create",
    explanation: "Membuat data periode kurban"
  },
  {
    subject: "periode_kurban",
    action: "Edit",
    explanation: "Mengubah data periode kurban"
  },
  {
    subject: "periode_kurban",
    action: "Delete",
    explanation: "Menghapus data periode kurban"
  },
  {
    subject: "donatur",
    action: "Read",
    explanation: "Melihat data donatur"
  },
  {
    subject: "daftar_donatur",
    action: "Read",
    explanation: "Melihat data daftar donatur"
  },
  {
    subject: "daftar_donatur",
    action: "Export Donatur",
    explanation: "Mengekspor data daftar donatur"
  },
  {
    subject: "daftar_donatur",
    action: "Create Donatur",
    explanation: "Membuat data donatur"
  },
  {
    subject: "detail_donatur",
    action: "Edit Donatur",
    explanation: "Mengubah data donatur"
  },
  {
    subject: "detail_donatur",
    action: "Ganti Password Donatur",
    explanation: "Mengubah password donatur"
  },
  {
    subject: "detail_donatur",
    action: "Penggabungan Donasi",
    explanation: "Menggabungkan data donasi"
  },
  {
    subject: "detail_donatur",
    action: "Cetak Konsolidasi",
    explanation: "Mencetak data konsolidasi"
  },
  {
    subject: "master_data",
    action: "Read",
    explanation: "Melihat data master"
  },
  {
    subject: "channel",
    action: "Read",
    explanation: "Melihat data channel"
  },
  {
    subject: "channel",
    action: "Create",
    explanation: "Membuat data channel"
  },
  {
    subject: "channel",
    action: "Edit",
    explanation: "Mengubah data channel"
  },
  {
    subject: "channel",
    action: "Delete",
    explanation: "Menghapus data channel"
  },
  {
    subject: "channel",
    action: "Migrasi Channel",
    explanation: "Migrasi data channel"
  },
  {
    subject: "benefis_category",
    action: "Read",
    explanation: "Melihat data kategori benefis"
  },
  {
    subject: "benefis_category",
    action: "Create",
    explanation: "Membuat data kategori benefis"
  },
  {
    subject: "benefis_category",
    action: "Edit",
    explanation: "Mengubah data kategori benefis"
  },
  {
    subject: "benefis_category",
    action: "Delete",
    explanation: "Menghapus data kategori benefis"
  },
  {
    subject: "bank",
    action: "Read",
    explanation: "Melihat data bank"
  },
  {
    subject: "bank",
    action: "Create",
    explanation: "Membuat data bank"
  },
  {
    subject: "bank",
    action: "Edit",
    explanation: "Mengubah data bank"
  },
  {
    subject: "bank_account",
    action: "Read",
    explanation: "Melihat data rekening bank"
  },
  {
    subject: "bank_account",
    action: "Create",
    explanation: "Membuat data rekening bank"
  },
  {
    subject: "bank_account",
    action: "Edit",
    explanation: "Mengubah data rekening bank"
  },
  {
    subject: "fund_type",
    action: "Read",
    explanation: "Melihat data jenis dana"
  },
  {
    subject: "fund_type",
    action: "Create",
    explanation: "Membuat data jenis dana"
  },
  {
    subject: "fund_type",
    action: "Edit",
    explanation: "Mengubah data jenis dana"
  },
  {
    subject: "payment_gateway",
    action: "Read",
    explanation: "Melihat data gateway pembayaran"
  },
  {
    subject: "payment_gateway",
    action: "Create",
    explanation: "Membuat data gateway pembayaran"
  },
  {
    subject: "payment_gateway",
    action: "Edit",
    explanation: "Mengubah data gateway pembayaran"
  },
  {
    subject: "payment_gateway",
    action: "Delete",
    explanation: "Menghapus data gateway pembayaran"
  },
  {
    subject: "payment_method",
    action: "Read",
    explanation: "Melihat data metode pembayaran"
  },
  {
    subject: "payment_method",
    action: "Create",
    explanation: "Membuat data metode pembayaran"
  },
  {
    subject: "payment_method",
    action: "Edit",
    explanation: "Mengubah data metode pembayaran"
  },
  {
    subject: "payment_method",
    action: "Delete",
    explanation: "Menghapus data metode pembayaran"
  },
  {
    subject: "program",
    action: "Read",
    explanation: "Melihat data program"
  },
  {
    subject: "program",
    action: "Create",
    explanation: "Membuat data program"
  },
  {
    subject: "program",
    action: "Edit",
    explanation: "Mengubah data program"
  },
  {
    subject: "program",
    action: "Delete",
    explanation: "Menghapus data program"
  },
  {
    subject: "template_notifikasi",
    action: "Read",
    explanation: "Melihat data template notifikasi"
  },
  {
    subject: "template_notifikasi",
    action: "Create",
    explanation: "Membuat data template notifikasi"
  },
  {
    subject: "template_notifikasi",
    action: "Edit",
    explanation: "Mengubah data template notifikasi"
  },
  {
    subject: "template_notifikasi",
    action: "Delete",
    explanation: "Menghapus data template notifikasi"
  },
  {
    subject: "master_kategori",
    action: "Read",
    explanation: "Melihat data kategori"
  },
  {
    subject: "master_kategori",
    action: "Create",
    explanation: "Membuat data kategori"
  },
  {
    subject: "master_kategori",
    action: "Edit",
    explanation: "Mengubah data kategori"
  },
  {
    subject: "master_kategori",
    action: "Delete",
    explanation: "Menghapus data kategori"
  },
  {
    subject: "kategori_barang",
    action: "Read",
    explanation: "Melihat data kategori barang"
  },
  {
    subject: "kategori_barang",
    action: "Create",
    explanation: "Membuat data kategori barang"
  },
  {
    subject: "kategori_barang",
    action: "Edit",
    explanation: "Mengubah data kategori barang"
  },
  {
    subject: "kategori_barang",
    action: "Delete",
    explanation: "Menghapus data kategori barang"
  },
  {
    subject: "master_option",
    action: "Read",
    explanation: "Melihat data Pilihan Master"
  },
  {
    subject: "master_option",
    action: "Create",
    explanation: "Membuat data Pilihan Master"
  },
  {
    subject: "master_option",
    action: "Edit",
    explanation: "Mengubah data Pilihan Master"
  },
  {
    subject: "master_option",
    action: "Delete",
    explanation: "Menghapus data Pilihan Master"
  },
  {
    subject: "access_role",
    action: "Read",
    explanation: "Melihat data Akses Role"
  },
  {
    subject: "access_role",
    action: "Create",
    explanation: "Membuat data Akses Role"
  },
  {
    subject: "access_role",
    action: "Edit",
    explanation: "Mengubah data Akses Role"
  },
  {
    subject: "analisa",
    action: "Read",
    explanation: "Melihat data Analisa"
  },
  {
    subject: "analisis_pertumbuhan_donatur",
    action: "Read",
    explanation: "Melihat data Analisis Pertumbuhan Donatur"
  },
  {
    subject: "analisis_pertumbuhan_donatur",
    action: "Export",
    explanation: "Mengekspor data Analisis Pertumbuhan Donatur"
  },
  {
    subject: "analisis_pertumbuhan_donatur",
    action: "Read Own Branch",
    explanation: "Melihat data Analisis Pertumbuhan Donatur Cabang Sendiri"
  },
  {
    subject: "analisis_ranking_donasi_donatur_berdasarkan_nominal",
    action: "Read",
    explanation:
      "Melihat data Analisis Ranking Donasi Donatur Berdasarkan Nominal"
  },
  {
    subject: "analisis_ranking_donasi_donatur_berdasarkan_nominal",
    action: "Export",
    explanation:
      "Mengekspor data Analisis Ranking Donasi Donatur Berdasarkan Nominal"
  },
  {
    subject: "analisis_ranking_donasi_donatur_berdasarkan_nominal",
    action: "Read Own Branch",
    explanation:
      "Melihat data Analisis Ranking Donasi Donatur Berdasarkan Nominal Cabang Sendiri"
  },
  {
    subject: "analisis_ranking_donasi_donatur_berdasarkan_item_donasi",
    action: "Read",
    explanation:
      "Melihat data Analisis Ranking Donasi Donatur Berdasarkan Item Donasi"
  },
  {
    subject: "analisis_ranking_donasi_donatur_berdasarkan_item_donasi",
    action: "Export",
    explanation:
      "Mengekspor data Analisis Ranking Donasi Donatur Berdasarkan Item Donasi"
  },
  {
    subject: "analisis_ranking_donasi_donatur_berdasarkan_item_donasi",
    action: "Read Own Branch",
    explanation:
      "Melihat data Analisis Ranking Donasi Donatur Berdasarkan Item Donasi Cabang Sendiri"
  },
  {
    subject: "analisis_keaktifan_donatur",
    action: "Read",
    explanation: "Melihat data Analisis Keaktifan Donatur"
  },
  {
    subject: "analisis_keaktifan_donatur",
    action: "Export",
    explanation: "Mengekspor data Analisis Keaktifan Donatur"
  },
  {
    subject: "analisis_keaktifan_donatur",
    action: "Read Own Branch",
    explanation: "Melihat data Analisis Keaktifan Donatur Cabang Sendiri"
  },
  {
    subject: "analisis_ranking_perolehan_konter",
    action: "Read",
    explanation: "Melihat data Analisis Ranking Perolehan Konter"
  },
  {
    subject: "analisis_ranking_perolehan_konter",
    action: "Export",
    explanation: "Mengekspor data Analisis Ranking Perolehan Konter"
  },
  {
    subject: "analisis_ranking_perolehan_konter",
    action: "Read Own Branch",
    explanation: "Mengekspor data Analisis Ranking Perolehan Konter"
  },
  {
    subject: "analisis_data_donatur_berdasarkan_jenis_donasi",
    action: "Read",
    explanation: "Melihat data Analisis Data Donatur Berdasarkan Jenis Donasi"
  },
  {
    subject: "analisis_data_donatur_berdasarkan_jenis_donasi",
    action: "Export",
    explanation:
      "Mengekspor data Analisis Data Donatur Berdasarkan Jenis Donasi"
  },
  {
    subject: "analisis_data_donatur_berdasarkan_jenis_donasi",
    action: "Read Own Branch",
    explanation:
      "Melihat data Analisis Data Donatur Berdasarkan Jenis Donasi Cabang Sendiri"
  },
  {
    subject: "analisis_data_donatur_berdasarkan_wilayah",
    action: "Read",
    explanation: "Melihat data Analisis Data Donatur Berdasarkan Wilayah"
  },
  {
    subject: "analisis_data_donatur_berdasarkan_wilayah",
    action: "Export",
    explanation: "Mengekspor data Analisis Data Donatur Berdasarkan Wilayah"
  },
  {
    subject: "analisis_data_donatur_berdasarkan_wilayah",
    action: "Read Own Branch",
    explanation:
      "Melihat data Analisis Data Donatur Berdasarkan Wilayah Cabang Sendiri"
  },
  {
    subject: "daftar_export",
    action: "Read",
    explanation: "Melihat data Daftar Export"
  },
  {
    subject: "daftar_export",
    action: "Create",
    explanation: "Membuat data Daftar Export"
  },
  {
    subject: "daftar_export",
    action: "Edit",
    explanation: "Mengubah data Daftar Export"
  },
  {
    subject: "daftar_export",
    action: "Delete",
    explanation: "Menghapus data Daftar Export"
  },
  {
    subject: "penyaluran",
    action: "Read",
    explanation: "Melihat data Penyaluran"
  },
  {
    subject: "benefis",
    action: "Read",
    explanation: "Melihat data Benefis"
  },
  {
    subject: "benefis",
    action: "Create",
    explanation: "Membuat data Benefis"
  },
  {
    subject: "benefis",
    action: "Edit",
    explanation: "Mengubah data Benefis"
  },
  {
    subject: "benefis",
    action: "Delete",
    explanation: "Menghapus data Benefis"
  },
  {
    subject: "distribution",
    action: "Read",
    explanation: "Melihat data Distribution"
  },
  {
    subject: "distribution",
    action: "Update",
    explanation: "Membuat data Distribution"
  },
  {
    subject: "distribution",
    action: "Edit",
    explanation: "Mengubah data Distribution"
  },
  {
    subject: "project",
    action: "Read",
    explanation: "Melihat data Project"
  },
  {
    subject: "project",
    action: "Create",
    explanation: "Membuat data Project"
  },
  {
    subject: "project",
    action: "Edit",
    explanation: "Mengubah data Project"
  },
  {
    subject: "partner-quota",
    action: "Read",
    explanation: "Melihat data Partner Quota"
  },
  {
    subject: "partner-quota",
    action: "Create",
    explanation: "Membuat data Partner Quota"
  },
  {
    subject: "organization",
    action: "Edit",
    explanation: "Mengubah data Organization"
  },
  {
    subject: "daftar_kurban",
    action: "Read",
    explanation: "Melihat Daftar Kurban"
  },
  {
    subject: "kurban-report",
    action: "Read",
    explanation: "Melihat Laporan Kurban"
  },
  {
    subject: "kurban-report",
    action: "Edit",
    explanation: "Mengubah Laporan Kurban"
  },
  {
    subject: "kurban-report",
    action: "Update",
    explanation: "Memperbaharui Laporan Kurban"
  },
  {
    subject: "campaign",
    action: "Read",
    explanation: "Melihat data Campaign"
  },
  {
    subject: "template-campaign",
    action: "Read",
    explanation: "Melihat data Template Campaign"
  },
  {
    subject: "template-campaign",
    action: "Create",
    explanation: "Membuat data Template Campaign"
  },
  {
    subject: "template-campaign",
    action: "Edit",
    explanation: "Mengubah data Template Campaign"
  },
  {
    subject: "template-campaign",
    action: "Delete",
    explanation: "Menghapus data Template Campaign"
  },
  {
    subject: "kirim_campaign",
    action: "Read",
    explanation: "Melihat data Kirim Campaign"
  },
  {
    subject: "kirim_campaign",
    action: "Create",
    explanation: "Membuat data Kirim Campaign"
  },
  {
    subject: "kirim_campaign",
    action: "Edit",
    explanation: "Mengubah data Kirim Campaign"
  },
  {
    subject: "kirim_campaign",
    action: "Delete",
    explanation: "Menghapus data Kirim Campaign"
  },
  {
    subject: "organization_feature",
    action: "Read",
    explanation: "Melihat data Organization Feature"
  },
  {
    subject: "organization_feature",
    action: "Create",
    explanation: "Membuat data Organization Feature"
  },
  {
    subject: "organization_feature",
    action: "Edit",
    explanation: "Mengubah data Organization Feature"
  },
  {
    subject: "organization_feature",
    action: "Delete",
    explanation: "Menghapus data Organization Feature"
  }
];

export const SUPERADMIN_TITLE_ROLE = {
  organization: "Data Lembaga",
  organization_feature: "Fitur Lembaga",
  organization_delete_data: "Hapus Data Lembaga",
  organization_report: "Laporan Lembaga",
  organization_consolidation: "Laporan Konsolidasi",
  organization_recapitulation: "Laporan Rekapitulasi",
  library: "Library",
  notification_organization: "Notifikasi Lembaga",
  notification_template: "Template Notifikasi",
  master_data_classification: "Master Data Klasifikasi",
  master_data_regional: "Master Data Regional",
  master_data_category: "Master Data Kategori",
  master_data_access_role: "Akses Role",
  master_data_user: "User"
};

export const SUPERADMIN_SUBJECT_ROLE = {
  create: "Buat Data",
  read: "Baca Data",
  edit: "Ubah Data",
  delete: "Hapus Data",
  manage: "Mengelola",
  disable: "Nonaktifkan Data (Soft Delete)",
  approval: "Approve lembaga"
};
